import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { userScopeCleared } from '@krp/client-runtime'
import { isIsoDay } from '@krp/ui-kit'

/** Намерение окна статистики магазина: выбранные дни и часовой пояс. Ответы службы — только в кэше запросов. */
export interface SalesPointsIntent { from: string; to: string; timeZoneId: string; refresh: number }
const initialState: SalesPointsIntent = { from: '', to: '', timeZoneId: 'Europe/Moscow', refresh: 0 }
const slice = createSlice({ name: 'salesPoints', initialState, reducers: {
  salesPointsPatched: (state, action: PayloadAction<Partial<SalesPointsIntent>>) => { Object.assign(state, action.payload) },
}, extraReducers: (builder) => {
  builder.addCase(userScopeCleared, () => initialState)
} })
export const { salesPointsPatched } = slice.actions
export const salesPointsReducer = slice.reducer
export function decodeSalesPointsIntent(raw: unknown): SalesPointsIntent | undefined {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return undefined
  const value = raw as Record<string, unknown>
  if (![value.from, value.to].every((day) => day === '' || typeof day === 'string' && isIsoDay(day))) return undefined
  if (!['Europe/Moscow', 'Asia/Yekaterinburg', 'UTC'].includes(String(value.timeZoneId))) return undefined
  return { from: String(value.from), to: String(value.to), timeZoneId: String(value.timeZoneId), refresh: 0 }
}
